import React, { memo, useCallback } from "react";
import colors from "app/colors";

import { ClockArrowPlusIcon } from "modules/icons";
import {
  AdminGrantHistoricalAccessMutation,
  AdminGrantHistoricalAccessMutationVariables,
  DistributionGroupFragment,
} from "gql/graphql";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { useMutation } from "@apollo/client";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION from "../_networking/admin-grant-historical-access";

interface IProps {
  distributionGroup?: DistributionGroupFragment;
  userId: string;
}

const AdminGrantHistoricalAccessButton = ({
  distributionGroup,
  userId,
}: IProps) => {
  const [adminGrantHistoricalAccessMutationAPI] = useMutation<
    AdminGrantHistoricalAccessMutation,
    AdminGrantHistoricalAccessMutationVariables
  >(ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION);

  const onClick = useCallback(() => {
    if (!distributionGroup) return;
    adminGrantHistoricalAccessMutationAPI({
      variables: {
        distributionGroupId: distributionGroup.id,
        userId,
      },
      optimisticResponse: {
        adminGrantHistoricalAccess: {
          __typename: "DistributionGroup",
          ...distributionGroup,
          historicalAccessUserIdList: [
            ...distributionGroup.historicalAccessUserIdList,
            userId,
          ],
        },
      },
    });
  }, [adminGrantHistoricalAccessMutationAPI, distributionGroup, userId]);

  if (
    !distributionGroup ||
    distributionGroup.historicalAccessUserIdList.includes(userId)
  ) {
    return null;
  }

  return (
    <SyncoTooltip label="Click to grant Historical Access">
      <CircularIconButton
        aria-label="grant historical access"
        variant="ghost"
        onClick={onClick}
        icon={<ClockArrowPlusIcon fill={colors.blue} boxSize={5} />}
      />
    </SyncoTooltip>
  );
};

export default memo(AdminGrantHistoricalAccessButton);
